'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


var STACK = 'react-navigation/STACK';

var TABS = 'react-navigation/TABS';
var DRAWER = 'react-navigation/DRAWER';

exports.default = {
  STACK: STACK,
  TABS: TABS,
  DRAWER: DRAWER
};


//////////////////
// WEBPACK FOOTER
// ./~/react-navigation/lib/navigators/NavigatorTypes.js
// module id = 63
// module chunks = 0